import React, {useCallback, useState} from 'react';
import Cropper from "react-easy-crop";
import {Button, Modal} from "react-bootstrap";
import { v4 as uuidv4 } from 'uuid';


function CropComponent({showCropDialog,setShowCropDialog, selectedImage, aspect, actualImage, handleChanges, baseUrl, accessToken, domain}) {

    const [crop, setCrop] = useState({x: 0, y: 0});
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

    // Function to handle crop changes
    const handleCropChange = (crop) => {
        setCrop(crop);
    };

    // Function to handle zoom changes
    const handleZoomChange = (zoom) => {
        setZoom(zoom);
    };

   
    //callback to run onCropComplete event to set the croppedAreaPixels
    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
    }, []);

    //callback to run zoomSlider
  const handleZoomSliderChange = (event) => {
    const zoomValue = parseFloat(event.target.value);
    setZoom(zoomValue);
  };

  // Function to handle cropping and set the cropped image as src
  const handleCropComplete = async (_) => {
    if (!selectedImage) return;
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const image = new Image();
    image.src = selectedImage.src;

    let trueSrc = actualImage.src;
    //creating image
    image.onload = async () => {
      // Set canvas to the crop area size
      canvas.width = croppedAreaPixels.width;
      canvas.height = croppedAreaPixels.height;

      // Calculate source and destination coordinates
      // This handles cases where crop extends beyond image (zoom < 1)
      const sourceX = Math.max(0, croppedAreaPixels.x);
      const sourceY = Math.max(0, croppedAreaPixels.y);
      const sourceWidth = Math.min(
        image.width - sourceX,
        croppedAreaPixels.width - Math.max(0, -croppedAreaPixels.x)
      );
      const sourceHeight = Math.min(
        image.height - sourceY,
        croppedAreaPixels.height - Math.max(0, -croppedAreaPixels.y)
      );

      // Destination coordinates on canvas (for centering when zoomed out)
      const destX = Math.max(0, -croppedAreaPixels.x);
      const destY = Math.max(0, -croppedAreaPixels.y);

      // Clear canvas with transparent background
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // Draw only the portion of the image that intersects with crop area
      ctx.drawImage(
        image,
        sourceX,
        sourceY,
        sourceWidth,
        sourceHeight,
        destX,
        destY,
        sourceWidth,
        sourceHeight
      );

      const croppedImageSrc = canvas.toDataURL("image/png");
      //set cropped src as actual image src
      actualImage.src = croppedImageSrc;

      const imageId = `image-${uuidv4().replace(/[^a-zA-Z]/g, '')}`;
      actualImage.classList.add(imageId)
      const extension = croppedImageSrc.split(';')[0].split('/')[1];
      // Add the edited image to the state
      let editedImages = [ { id: imageId, originalSrc: trueSrc, editedDataUrl: croppedImageSrc, extension : extension }]

      try {
        // Send the edited images to the API
        const response = await fetch(`${baseUrl}v3/editor/upload-image`, {
          method: "POST",
          body: JSON.stringify({
            uploadedImages: editedImages,
            domain: domain,
          }),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        });

        if (response.ok) {
          const data = await response.json();
          const uploadedUrls = data.uploadedUrls;
          for (const uploadedImage of uploadedUrls) {
            actualImage.src =  `https://${domain}${uploadedImage.src}`;
            actualImage.classList.remove(uploadedImage.id);
          }
        }
      } catch (error) {
        console.error("Error uploading edited images:", error);
      }

      handleChanges()
      
    };

    setShowCropDialog(false);
  };



    return (
        <Modal show={showCropDialog} onHide={() => setShowCropDialog(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Crop Image</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ marginBottom: '10px', padding: '8px', backgroundColor: '#f8f9fa', borderRadius: '4px', fontSize: '14px', color: '#6c757d' }}>
            <i className="bi bi-info-circle" style={{ marginRight: '5px' }}></i>
            Images must be less than 500KB in size.
          </div>
          {selectedImage && (
            <>
              <Cropper
                image={selectedImage.src}
                crop={crop}
                zoom={zoom}
                aspect={aspect}
                minZoom={0.1}
                maxZoom={3}
                restrictPosition={false}
                onCropChange={handleCropChange}
                onZoomChange={handleZoomChange}
                onCropComplete={onCropComplete}
              />
              {/* Slider to control zoom */}
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <input
            type="range"
            min="0.1"
            max="3"
            step="0.1"
            value={zoom}
            onChange={handleZoomSliderChange}
          />
          <Button variant="secondary" onClick={() => setShowCropDialog(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={() => {
            handleCropComplete()
          }}>
            Crop
          </Button>
        </Modal.Footer>
      </Modal>
    );
}

export default CropComponent;